import React from "react";
import Card from "./Card";
import CourseContent from "./CourseContent";

const CardList = ({ courses }) => {
  return (
    <div>
      {courses.map((course, i) => {
        return (
          <div key={course.id}>
            <Card id={course.id} name={course.name} url={"/" + course.id} />
            <CourseContent course={course} />
          </div>
        );
      })}
    </div>
  );
};

export default CardList;



// WEBPACK FOOTER //
// ./src/components/CardList.js